import { apiCall, type ApiClientConfig } from "@playbookai/api-clients";
import type { TtiTrackingMode } from "@playbookai/types";

export interface KpiTtiBowlingEntry {
  readonly periodMonth: string;
  readonly planValue: string | null;
  readonly actualValue: string | null;
  readonly remark: string | null;
  readonly updatedAt: string;
}

export interface KpiTtiBowlingSeries {
  readonly targetId: string;
  readonly trackingMode: TtiTrackingMode;
  readonly periodStart: string | null;
  readonly periodEnd: string | null;
  readonly canSetMonthlyTargets: boolean;
  readonly canRecordMonthlyActuals: boolean;
  readonly entries: readonly KpiTtiBowlingEntry[];
}

export interface SetKpiTtiMonthlyTargetsInput {
  readonly months: ReadonlyArray<{
    readonly periodMonth: string;
    readonly planValue: string | null;
  }>;
}

export interface RecordKpiTtiMonthlyActualInput {
  readonly actualValue: string | null;
  readonly remark?: string | null;
}

const path = (ttiId: string) =>
  `/v1/hoshin-ttis/${encodeURIComponent(ttiId)}/bowling`;

export const kpiTtiBowlingApi = {
  getSeries(
    config: ApiClientConfig,
    ttiId: string,
  ): Promise<KpiTtiBowlingSeries> {
    return apiCall<KpiTtiBowlingSeries>(config, "GET", path(ttiId));
  },

  setMonthlyTargets(
    config: ApiClientConfig,
    ttiId: string,
    input: SetKpiTtiMonthlyTargetsInput,
  ): Promise<KpiTtiBowlingSeries> {
    return apiCall<KpiTtiBowlingSeries>(
      config,
      "PUT",
      `${path(ttiId)}-plan`,
      input,
    );
  },

  recordMonthlyActual(
    config: ApiClientConfig,
    ttiId: string,
    periodMonth: string,
    input: RecordKpiTtiMonthlyActualInput,
  ): Promise<KpiTtiBowlingEntry> {
    return apiCall<KpiTtiBowlingEntry>(
      config,
      "PUT",
      `${path(ttiId)}/${encodeURIComponent(periodMonth)}`,
      input,
    );
  },
};
